import { browser } from '$app/environment';
import { get } from 'svelte/store';
import { useClient } from './client';
import type { Account } from '$lib/account/account';
import { API } from 'aws-amplify';
import type { GraphQLQuery } from '@aws-amplify/api';
import { parseFunction } from '$lib/helpers';
import type { ClientType } from '$lib/form/form-store';
import { getUserIdByAccount } from '$lib/account/get-user-id-by-account';

export const getClientByAccount = async (force = false, account: Account | null | undefined) => {
	if (!browser) return null;

	// account not authed
	if (!account) return account;

	const { client, username } = useClient();
	const c = get(client);
	const un = get(username);

	// check account, get username. if username exist and match with account username
	// then reuse client data.
	if (!force && c && account && un === account.username) return c;

	// if username not match then fetch new

	// send request to get user id from cognito

	// get user id from database
	const { id, email } = await getUserIdByAccount(account);
	// console.log('user id', id);
	// console.log('user email', email);
	
	// find client data
	const fetcher = await API.graphql<GraphQLQuery<any>>({
		query: /* GraphQL */ `
			mutation AppClientInfo($input: AppClientInfoInput!) {
				appClientInfo(input: $input) {
					clientMutationId
					results {
						userId
						clientId
						nameFirst
						nameLast
						email
						phone
						sourceId
						addresses
						students
						stripeCustomerId
					}
				}
			}
		`,
		variables: {
			input: {
				input: JSON.stringify({
					user_id: id
				})
			}
		}
	});

	// client data
	const clientData = parseFunction(fetcher.data.appClientInfo.results[0]) as ClientType;
	clientData.email = email;

	// save into store
	client.set(clientData);
	username.set(account.username);
	return get(client);
};
